export type PackageItem = {
    slug: string
    eyebrow: string
    name: string
    price: string
    image: string
    alt: string
    description: string
}

export type PackagesQuote = {
    quote: string
    name: string
    image: string
}

/** Ways to stay, taken from the original's reservations and Red Cabin pages. */
export const packageItems: PackageItem[] = [
    {
        slug: 'summer-weeks',
        eyebrow: 'For July & August',
        name: 'Summer Weeks',
        price: 'Sunday to Sunday',
        image: '/images/blue-cabin-lake-porch.jpg',
        alt: 'White wicker chairs on a cabin porch looking out to Lake Superior',
        description: 'To accommodate our returning guests during our peak months of July and August, we book week long stays Sunday to Sunday. Please call to book these months.'
    },
    {
        slug: 'winter-rentals',
        eyebrow: 'For Winter',
        name: 'Long Term Winter Rentals',
        price: 'Call for rates',
        image: '/images/red-cabin-entrance.jpg',
        alt: 'The Red Cabin entrance beneath towering pines',
        description: 'The Red Cabin is our Four Season accommodation for up to 6 people, steps from prime ice-fishing areas and a short ride from hundreds of miles of snowmobile trails.'
    },
    {
        slug: 'blue-and-gray-together',
        eyebrow: 'For Big Groups',
        name: 'Blue & Gray Together',
        price: 'Call for rates',
        image: '/images/blue-cabin-dining-area.jpg',
        alt: 'Blue Cabin dining table and swivel chairs on wide plank floors',
        description: 'The Blue and Gray can be rented together or separately, with large sofas, a big kitchen and wet bar, and extra seating for a big group.'
    }
]

/** Quote band on /packages. It only renders when a real guest or owner quote is set. */
export const packagesQuote: PackagesQuote | null = null
